var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"run-time-wrap"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"run-time",domProps:{"innerHTML":_vm._s(_vm.translateTime)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }